import { EspAccount, TrackingDomain } from '../types';

export const createSendingModalDropdownOptions = (espAccounts: EspAccount[] = []) => {
  return espAccounts.map((account) => {
    return {
      id: account.id,
      value: account.id,
      label: account.name,
      doubleLine: `ID: ${account.id} | ESP: ${account.esp}`,
    };
  });
};

export const setTrackingModalDropdownOptions = (trackingDomains: TrackingDomain[] = []) => {
  return trackingDomains.map(({ domain }) => {
    return {
      id: domain,
      value: domain,
      label: domain,
    };
  });
};
